import React, { useEffect, useState } from 'react';
import { colors } from '../../../../constants/colors';
import { fonts } from '../../../../constants/fonts';
import { handleNumberInputWithoutDecimal } from '../../../../constants/globalFunction';
import CommonInput from '../../../../components/input/CommonInput';
import './CartQtyUpdateModal.css';

const CartQtyUpdateModal = ({ visible, onCancel, onApply, initialQty }) => {
    const [qty, setQty] = useState(initialQty);

    useEffect(() => {
        setQty(initialQty);
    }, [initialQty, visible]);

    const onChangeQty = (text) => {
        setQty(handleNumberInputWithoutDecimal(text));
    };

    const onApplyQty = () => {
        if (!qty.trim() || parseInt(qty) <= 0) {
            return;
        }
        onApply(qty);
    };

    if (!visible) return null;

    return (
        <div className="cart-qty-modal-overlay">
            <div className="cart-qty-modal-container">
                <h3 className="cart-qty-modal-title">Enter Quantity</h3>
                <CommonInput
                    type="text"
                    value={qty}
                    onChange={onChangeQty}
                    placeholder="Quantity"
                />
                <div className="cart-qty-modal-button-row">
                    <button 
                        className="cart-qty-modal-button cart-qty-modal-cancel" 
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                    <button 
                        className="cart-qty-modal-button cart-qty-modal-apply" 
                        onClick={onApplyQty}
                        disabled={!qty || parseInt(qty) <= 0}
                    >
                        Apply
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CartQtyUpdateModal;